import { render, staticRenderFns } from "./StockRecord.vue?vue&type=template&id=4dbdf864&scoped=true&"
import script from "./StockRecord.vue?vue&type=script&lang=ts&"
export * from "./StockRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbdf864",
  null
  
)

export default component.exports